require('dotenv').config();
const { toBaseURL } = require('./utils/business');
const origin = window.location.origin;
const PUBLIC_ENDPOINT = origin;
const BASE_URL = toBaseURL(PUBLIC_ENDPOINT);
const BIZ_PROCESS = `/biz-process`;
const DATA_PROVIDER = `/data-provider`;

const REPORT = `/report`;
console.log('PUBLIC_ENDPOINT: ' + PUBLIC_ENDPOINT);
console.log('BASE_URL: ' + BASE_URL);

export const URL = {
    calculatorV2: `${BASE_URL}${BIZ_PROCESS}/api/calculator`,
    fileV2: `${BASE_URL}${BIZ_PROCESS}/api/file`,
    loginV2: `${BASE_URL}${DATA_PROVIDER}/api/user/login`,
    renewTokenV2: `${BASE_URL}${DATA_PROVIDER}/api/user/renew-token`,
    deleteUserV2: `${BASE_URL}${DATA_PROVIDER}/api/user/delete-user`,
    uploadManagementV2: `${BASE_URL}${DATA_PROVIDER}/api/upload-management`,
    batchV2: `${BASE_URL}${DATA_PROVIDER}/api/batch`,
    capitalPlanning: `${BASE_URL}${DATA_PROVIDER}/api/cap`,
    roleListV2: `${BASE_URL}${DATA_PROVIDER}/api/role/role-list`,
    updateRoleV2: `${BASE_URL}${DATA_PROVIDER}/api/role/update-role`,
    createRoleV2: `${BASE_URL}${DATA_PROVIDER}/api/role/create-role`,
    listUserV2: `${BASE_URL}${DATA_PROVIDER}/api/user/list-user`,
    createUserV2: `${BASE_URL}${DATA_PROVIDER}/api/user/create-user`,
    updateUserV2: `${BASE_URL}${DATA_PROVIDER}/api/user/update-user`,
    versionV2: `${BASE_URL}${DATA_PROVIDER}/api/version`,
    listActionLogsV2: `${BASE_URL}${DATA_PROVIDER}/api/action-log`,
    masterTableV2: `${BASE_URL}${DATA_PROVIDER}/api/master-table`,
    listReportV2: `${BASE_URL}${DATA_PROVIDER}/api/report/list-reports`,
    downloadV2: `${BASE_URL}${DATA_PROVIDER}/api/download`,
    downloadReportType: `${BASE_URL}${REPORT}/api/report-by-type`,
}

export const LimitRecord = 15;

export const MasterTableType = {
    none: 0,
    party_type: 1,
    business_sector: 2,
    loan_purpose_type: 3,
    collateral_master: 4,
    other_assets: 5,
}

export const ErrorCode = {
    PermissionDenie: 403,
    UnknowError: 800,
    Exist: 701,
    NotExist: 702,
    TooMuch: 703,
    Empty: 704,
    DataInvalid: 705,
    PendingUpload: 706,
    UploadCompleted: 707,
    PendingBatchProcessing: 708,
    BatchProcessingFailed: 709,
    BatchProcessingCompleted: 710,
    UploadOnlySuccessful: 711,
    UploadAndMergeSuccessful: 712,
    JwtExpired: 713,
    UploadFormSuccessful: 714,
    ReplaceFileSuccessful: 715,
    BatchEmpty: 716,
    WeakPassword: 717,
    FileInvalid: 718,
    DownloadFailed: 719,
    PendingDownload: 720,
    DownloadCompleted: 721,
}

export const RoleGroupId = {
    Admin: "1",
    User: "2"
}

export const AccountType = {
    Admin: "1",
    User: "2"
}

export const FileExtension = {
    XLSX: "XLSX",
    CSV: "CSV",
    TXT: "TXT"
}

export const AccountTypeName = {
    "1": "Admin",
    "2": "User"
}

export const REPORT_NAME_MAPPING = {
    CR3: 'CR3',
    CR4: 'CR4',
    CAR3_01: 'CAR3-01',
    CAR3_01_CONSOL: 'CAR3-01-CONSOL',
    CAR3_02: 'CAR3-02',
    CAR3_03: 'CAR3-03',
    CAR3_04: 'CAR3-04',
    CAR3_04_CONSOL: 'CAR3-04-CONSOL',
    CAR3_05: 'CAR3-05',
    CAR3_05_CONSOL: 'CAR3-05-CONSOL',
    CAR3_06: 'CAR3-06',
    CAR3_06_CONSOL: 'CAR3-06-CONSOL',
    CAR3_07: 'CAR3-07',
    CAR3_07_CONSOL: 'CAR3-07-CONSOL',
    CAR3_08: 'CAR3-08',
    CAR3_08_CONSOL: 'CAR3-08-CONSOL',
    CAR3_09: 'CAR3-09',
    CAR3_09_CONSOL: 'CAR3-09-CONSOL',
    CAR3_10: 'CAR3-10',
    CAR3_10_CONSOL: 'CAR3-10-CONSOL',
    CAR3_11: 'CAR3-11',
    CAR3_11_CONSOL: 'CAR3-11-CONSOL',
    CAR3_13: 'CAR3-13',
    CAR3_13_CONSOL: 'CAR3-13-CONSOL',
    CAR3_14_CONSOL: 'CAR3-14-CONSOL',
    MR1: 'MR1',
    MR1_CONSOL: 'MR1-CONSOL',
    CCR1: 'CCR1',
    CCR1_CONSOL: 'CCR1-CONSOL',
    CAR3_12: 'CAR3-12',
    CAR3_12_CONSOL: 'CAR3-12-CONSOL',
    ICAAP3_01: 'ICAAP3-01',
    ICAAP3_07: 'ICAAP3-07',
    ICAAP3_08: 'ICAAP3-08',
    KM1_C: 'KM1-C',
    OV1_C: 'OV1-C',
    CR1: 'CR1',
    CVA1: 'CVA1',
    CVA1_CONSOL: 'CVA1-CONSOL',
    LR1: 'LR1',
    LR1_CONSOL: 'LR1-CONSOL',
    CRB: 'CRB',
    CR5: 'CR5',
    CAPITAL: 'CAPITAL_',
    ICAAP3_06: 'ICAAP3-06',
    ICAAP3_10: 'ICAAP3-10',
    ICAAP3_14: 'ICAAP3-14',
    ICAAP3_05: 'ICAAP3-05',
    ICAAP3_04: 'ICAAP3-04',
    ICAAP3_09: 'ICAAP3-09',
    ICAAP3_13: 'ICAAP3-13',
    ICAAP3_12: 'ICAAP3-12',
    ICAAP3_11: 'ICAAP3-11',
    ICAAP3_02: 'ICAAP3-02',
    ICAAP3_03: 'ICAAP3-03'
}

export const INTERMEDIATE_OUTPUT_FILES = {
    'CR_COR': [
        'MAPPING_CAR_ICAAP_MASTER_CR_TRACING',
        'MAPPING_CAR_ICAAP_MASTER_CR',
        'CR00_STAGING_CR_ETL',
        'CR01_BASE_CASE',
        'CR02_STRESS_CASE',
        'CR03_IMPACT_CONSOLIDATION',
        'COR00_STAGING_COR_ETL_CUSTOMER',
        'COR00_STAGING_COR_ETL_GROUP',
        'COR00_STAGING_COR_ETL_SECTOR',
        'COR01_BASE_CASE_CUSTOMER',
        'COR01_BASE_CASE_GROUP',
        'COR01_BASE_CASE_SECTOR',
        'COR02_STRESS_CASE_CUSTOMER',
        'COR02_STRESS_CASE_GROUP',
        'COR02_STRESS_CASE_SECTOR',
        'COR03_IMPACT_CONSOLIDATION',
        'REGULATORY_CAR',  
    ],
    'MR_CCR': [
        '_INT_RATE_INTERP',
        '_MTM_CAL_RESULT',
        '_FX_SHOCKED_RESULT',
        '_GIRR_SHOCKED_RESULT',
        '_STG_MR_INSTRUMENT',
        '_STG_SENSI_CSR_NONSEC',
        '_STG_SENSI_FX',
        '_STG_PARTY_RATING_DETAILS',
        '_STG_SENSI_GIRR',
        '_PROCESSING_PARTY_RATING_CCR',
        '_CRW_RATING_STRESS',
        'STG_PARTY_MASTER_CCR',
        'STG_NETTING',
        'STG_PARTY_RATING_DETAILS',
        'OUT_MTM_SCENARIOS',
        'OUT_DELTA_PNL_MR',
        'OUT_DELTA_RWA_MR',
        'OUT_DELTA_RWA_CCR',
        'OUT_DELTA_RWA_CVA',
        '_DETAIL_FAILED_TRADE',
        '_DETAIL_CVA',
        '_DETAIL_EAD',
        '_DETAIL_SCVA_CVA',
        '_RWA_REPO',
        '_STG_SENSI_FX_USING',
        '_STG_SENSI_FX_S',
        '_STG_SENSI_FX_C',
        '_STG_SENSI_GIRR_USING',
        '_STG_SENSI_GIRR_S',
        '_STG_SENSI_GIRR_C',
        '_DETAIL_SA_MR',
        '_DRC',
        '_DRC_BUCKET',
        '_DELTA_CSR_NONSEC_SUM_SENSITIVITY',
    ],
    'OR': [
        '_STRESSED_KOR_',
        '_REPORTING_NORMAL_SCENARIO_OR_',
        '_CRISIS_SCENARIO_OR_',
    ],
    'LR': [
        '_REPORTING_LIQ_COST_T',
        '_REPORTING_DETAIL_LIQ_COST_RESULTS',
    ],
    'IRRBB': [
        '_IRRBB_SHOCK_SCENARIO_BASE_',
        '_IRRBB_SHOCK_SCENARIO_SHOCK_',
        '_DETAIL_IRRBB_BASE_',
        '_DETAIL_IRRBB_SHOCK_',
    ]
}


// WEBPACK FOOTER //
// ./src/const.js